import React from "react";
import Zoom from "@mui/material/Zoom";
import { styled } from "@mui/material/styles";
import TooltipMui, {
  TooltipProps,
  tooltipClasses,
} from "@mui/material/Tooltip";

import IconSvg from "../IconSvg";

import iconInfo from "../../assets/icon-info.svg";

import { ContainerIcon } from "./styles";

interface InputProps {
  title: string;
  maxWidth?: number;
  placement?:
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | "top";
}

const TooltipInformation: React.FC<InputProps> = ({
  title,
  placement,
  maxWidth,
}) => {
  const CustomTooltipMui = styled(({ className, ...props }: TooltipProps) => (
    <TooltipMui {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: maxWidth ? maxWidth : 100,
      fontSize: 12,
      textAlign: "center",
      fontWeight: 500,
      backgroundColor: "#000",
      boxShadow: `0px 0px 5px 0px #775797`,
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: "#000",
    },
  });

  return (
    <CustomTooltipMui
      title={title}
      placement={placement}
      arrow
      TransitionComponent={Zoom}
      enterDelay={100}
    >
      <ContainerIcon>
        <IconSvg width="16" height="16" image={iconInfo} />
      </ContainerIcon>
    </CustomTooltipMui>
  );
};

export default TooltipInformation;
